import React from 'react';
import FieldView from "../../../../components/FieldView";
import {formDefFazendaLeite} from "../forms";
import {QuestionarioFazendaObject} from "../../../../models/Questionario";

interface QuestionarioLeiteV2Props {
  questionario: QuestionarioFazendaObject
}

const QuestionarioLeiteV2: React.FC<QuestionarioLeiteV2Props> = ({questionario}) => {
  return (
    <>
      <div className="text-xl font-hairline mt-6">
        Fazendas de leite
      </div>

      <FieldView value={questionario.intervalo_entre_partos}
                 def={formDefFazendaLeite.intervalo_entre_partos}/>

      <div className="text-xl font-hairline mt-6">
        Rebanho de Leite
      </div>
      <FieldView value={questionario.vacas_ordenhadas}
                 def={formDefFazendaLeite.vacas_ordenhadas}/>
      <FieldView value={questionario.leite_vacas_secas}
                 def={formDefFazendaLeite.leite_vacas_secas}/>
      <FieldView value={questionario.leite_novilhas}
                 def={formDefFazendaLeite.leite_novilhas}/>
      <FieldView value={questionario.leite_bezerras}
                 def={formDefFazendaLeite.leite_bezerras}/>
    </>
  );
}

export default QuestionarioLeiteV2;
